var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.404 211.609C137.492 205.309 128.148 200.021 118.109 196.631C70.816 180.66 19.943 207.318 4.484 256.172C-10.977 305.023 14.83 357.574 62.123 373.543L372.416 478.322C385.359 482.664 400.166 478.494 409.002 466.754C420.269 451.775 417.652 430.195 403.152 418.555L145.404 211.609ZM96.166 319.666C78.586 319.666 64.334 305.414 64.334 287.832C64.334 270.252 78.586 256 96.166 256C113.748 256 128 270.252 128 287.832C128 305.414 113.748 319.666 96.166 319.666ZM352 32C298.98 32 256 74.98 256 128S298.98 224 352 224S448 181.02 448 128S405.019 32 352 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinball);
export default __webpack_public_path__ + "static/media/pinball.ba61c922753dc2962295250295c93397.svg";
export { ForwardRef as ReactComponent };